import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

import Sidebar from 'components/sidebar';
import AppRoutes from 'components/app/app-routes';
import * as constants from 'app-constants';
import InitAppContext from 'components/context/init-app-context';
import withFetchInitialSplitFlags from './with-fetch-initial-flags-hoc';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh'
  },
  appContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing.unit * 6
  }
}));

function AppComponent() {
  const classes = useStyles();
  return (
    <>
      <BrowserRouter basename={constants.PATH_BASE}>
        <div className={classes.root}>
          <nav>
            <InitAppContext />
            <Sidebar />
          </nav>
          <div className={classes.appContent}>
            <AppRoutes />
          </div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default withFetchInitialSplitFlags(AppComponent);
